import actions from '../../constants';

export const changeMobileMenu = () => (dispatch, getState) => {
  const data = !getState().system.get('toggleMobileMenu');
  dispatch({
    type: actions.TOGGLE_MOBILE_MENU,
    data
  });
};



// WEBPACK FOOTER //
// ./src/redux/actions/portal/system.js